(() => {
  function initialise(scope) {
    if (scope.dataset.sntInitialised) return;
    scope.dataset.sntInitialised = 'true';
    const variants = JSON.parse(scope.querySelector('[data-snt-pickup-variants]').textContent);
    const update = () => {
      const form = document.getElementById(scope.dataset.productFormId);
      const id = form?.querySelector('input[name="id"]')?.value;
      const variant = variants.find(item => String(item.id) === String(id));
      const preorder = Boolean(variant?.preorder);
      scope.classList.toggle('snt-preorder-selected', preorder);
      const note = scope.querySelector('.snt-preorder-pickup-note');
      if (note) note.hidden = !preorder;
    };
    scope.addEventListener('change', () => queueMicrotask(update));
    update();
  }
  function initialiseAll(root) { root.querySelectorAll('[data-snt-product]').forEach(initialise); }
  initialiseAll(document);
  document.addEventListener('shopify:section:load', event => initialiseAll(event.target));
})();